<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button
        (click)="modalCtrl.dismiss()"
        fill="clear"
      >
        <ion-icon
          size="large"
          name="close"
          aria-label="close"
          slot="icon-only"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="mable-section ion-margin-top">
    <img
      class="width-100 ion-padding-horizontal"
      src="assets/img/mable/paper-plane.svg"
      alt="paper plane"
    />

    <mable-heading heading="h2">
      Nice one!
      <span>
        {{ isAutoApproved ? 'Your account details are complete' : 'Account verification sent' }}
      </span>
    </mable-heading>

    <div class="sub-section ion-margin-horizontal">
      <p
        class="body-lead-16-bold"
        [innerHTML]="
          isAutoApproved
            ? 'Next, complete your profile. It will only be shared with support workers after you\'ve formally agreed to receive support from them. This helps them understand how to best support you. Your profile will include:
            <ul>
              <li>Your interests</li>
              <li>Medical details</li>
              <li>Support needs</li>
            </ul>'
            : fundingSourceCode === 'ndis_self_managed'
              ? 'We\'ll review your documents and send you an email when your account is verified. You\'ll then be able to book support workers to provide you support.'
              : 'We\'ll review and send you an email when your account is verified. You\'ll then be able to book support workers to provide you support.'
        "
      ></p>

      <p *ngIf="!isAutoApproved">
        While we process your verification,
        {{
          hasAgreement
            ? "complete your profile to share with support workers
        you're in an agreement with. Your profile will include:"
            : 'continue to find workers for your support needs.'
        }}
      </p>

      <ul *ngIf="hasAgreement">
        <li>Your interests</li>
        <li>Medical information</li>
        <li>Support needs</li>
      </ul>
    </div>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <mable-button
      category="orange-500"
      (onClick)="redirect()"
      expand="block"
    >
      {{ isAutoApproved ? 'Complete your profile' : 'Search workers' }}
    </mable-button>

    <mable-button
      *ngIf="isAutoApproved"
      category="outline"
      (onClick)="goDashboard()"
      expand="block"
    >
      Back to dashboard
    </mable-button>
  </ion-toolbar>
</ion-footer>
